import { observer } from 'mobx-react-lite';
import React, { FC, useEffect } from 'react';
import { RootStore } from './stores/root-store';

const store = new RootStore();

export const RootStoreContext = React.createContext(store);

interface RootStoreProviderProps {
  children: React.ReactNode;
  mockStore?: RootStore;
  initState?: (rootStore: RootStore) => void;
}

export const RootStoreProvider: FC<RootStoreProviderProps> = observer(
  ({ children, initState, mockStore }) => {
    const storeValue = mockStore ?? store;

    useEffect(() => {
      if (initState) {
        initState(storeValue);
      }
    }, [initState, storeValue]);

    return <RootStoreContext.Provider value={storeValue}>{children}</RootStoreContext.Provider>;
  },
);
